require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-what-is-ecommerce-marketing.json") })
        }
      }, "path---blog-what-is-ecommerce-marketing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-what-is-ecommerce-marketing!./.cache/json/blog-what-is-ecommerce-marketing.json
// module id = 513
// module chunks = 231608221292675